/* AGS — Methodology page: reveals, shelf parallax, story stage, modal.
   Ported from the approved Apex Field artifact (p-methodology). Layout is
   decided by CSS at 900px; this script only has to know which one is showing. */
(function () {
  var page = document.getElementById('p-methodology');
  var dataEl = document.getElementById('knData');
  if (!page || !dataEl) return;
  document.documentElement.classList.add('kn-js');
  var V;
  try { V = JSON.parse(dataEl.textContent); } catch (_) { return; }
  if (!V.length) return;
  var rm = window.matchMedia('(prefers-reduced-motion: reduce)');
  var narrow = window.matchMedia('(max-width: 900px)');
  var pad2 = function (n) { return ('0' + n).slice(-2); };

  /* reveals — IO gated; anything already in view is marked on the first pass */
  var rv = [].slice.call(page.querySelectorAll('.kn-rv'));
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: .06 });
    rv.forEach(function (el) { io.observe(el); });
  } else {
    rv.forEach(function (el) { el.classList.add('is-in'); });
  }

  /* shelf parallax — transform only, one rAF, only while the hero is on screen */
  var shelf = document.getElementById('knShelf'), items = shelf ? [].slice.call(shelf.children) : [],
      hero = page.querySelector('.kn-hero');
  var rates = [-.055, .04, -.03, .06, -.045, .05, -.035, .045, -.06, .035, -.04, .05], ticking = false,
      wide = window.matchMedia('(min-width: 701px)');
  function para() {
    ticking = false;
    if (rm.matches || !wide.matches) { items.forEach(function (b) { b.style.setProperty('--py', '0px'); }); return; }
    var r = hero.getBoundingClientRect(); if (r.bottom < 0) return;
    var y = -r.top;
    items.forEach(function (b, i) { b.style.setProperty('--py', (y * (rates[i] || 0)).toFixed(1) + 'px'); });
  }
  function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(para); } }
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);

  /* story stage — the sticky cover follows the entry nearest the middle of the viewport */
  var stack = document.getElementById('knStack'), covers = stack ? [].slice.call(stack.children) : [],
      entries = [].slice.call(document.querySelectorAll('#knFlow .kn-entry')),
      capT = document.getElementById('knCapT'), progEl = document.getElementById('knProg'),
      prog = progEl ? [].slice.call(progEl.children) : [],
      stg = document.querySelector('#p-methodology .kn-stage'), cur = 0;
  function setStage(i) {
    if (i === cur) return; cur = i;
    covers.forEach(function (c, k) { c.classList.toggle('is-on', k === i); });
    entries.forEach(function (e, k) { e.classList.toggle('is-on', k === i); });
    prog.forEach(function (p, k) { p.classList.toggle('is-on', k <= i); });
    if (capT) capT.textContent = 'Guide ' + pad2(V[i].n);
  }
  var sTick = false;
  function stage() {
    sTick = false;
    if (narrow.matches || !stg || !entries.length) return;
    /* the last entry whose top has passed the line is current (monotonic, never skips);
       at the very end of the page the last guide is current whatever the line says */
    var sr = stg.getBoundingClientRect(), line = sr.height ? sr.top + sr.height * .5 : window.innerHeight * .45, best = 0;
    var atEnd = window.pageYOffset + window.innerHeight >= document.documentElement.scrollHeight - 2;
    if (atEnd) best = entries.length - 1;
    else entries.forEach(function (e, k) { if (e.getBoundingClientRect().top <= line) best = k; });
    setStage(best);
  }
  window.addEventListener('scroll', function () { if (!sTick) { sTick = true; requestAnimationFrame(stage); } }, { passive: true });
  if (entries.length) entries[0].classList.add('is-on');

  /* modal */
  var dlg = document.getElementById('knDlg'), img = document.getElementById('knDlgImg'), open = -1, lastFocus = null;
  var $ = function (id) { return document.getElementById(id); };
  function fill(i) {
    var v = V[i]; open = i;
    $('knDlgE').textContent = 'Guide ' + pad2(v.n);
    $('knDlgT').textContent = v.title; $('knDlgD').textContent = v.line || '';
    var dl = $('knDlgDl'), pv = $('knDlgPv');
    if (v.pdf) { dl.href = v.pdf; dl.hidden = false; if (pv) { pv.setAttribute('data-pv-url', v.pdf); pv.setAttribute('data-pv-name', v.title); pv.hidden = false; } }
    else { dl.hidden = true; if (pv) pv.hidden = true; }
    setPg(1);
    var p = $('knPrev'), n = $('knNext');
    p.disabled = i === 0; n.disabled = i === V.length - 1;
    if (i > 0) p.querySelector('b').textContent = pad2(V[i - 1].n) + ' · ' + V[i - 1].short;
    if (i < V.length - 1) n.querySelector('b').textContent = pad2(V[i + 1].n) + ' · ' + V[i + 1].short;
    dlg.querySelector('.kn-dlg__body').scrollTop = 0;
  }
  function setPg(pg) {
    var v = V[open]; img.src = pg === 2 ? v.p2 : v.cover; img.dataset.pg = pg;
    img.alt = (pg === 2 ? 'Publication record page of ' : 'Cover of ') + v.title;
    dlg.querySelectorAll('.kn-dlg__tabs button').forEach(function (b) { b.setAttribute('aria-pressed', String(+b.dataset.pg === pg)); });
  }
  function show(i) {
    lastFocus = document.activeElement; fill(i);
    if (typeof dlg.showModal === 'function') { dlg.showModal(); } else dlg.setAttribute('open', '');
    document.body.style.overflow = 'hidden'; $('knDlgX').focus();
  }
  function hide() {
    if (dlg.open) dlg.close(); document.body.style.overflow = '';
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  page.addEventListener('click', function (e) {
    var t = e.target.closest('[data-kn]'); if (t) { e.preventDefault(); show(+t.dataset.kn); return; }
    var s = e.target.closest('[data-kn-scroll]');
    if (s) {
      e.preventDefault();
      var el = document.getElementById('kn-docs'); var y = el.getBoundingClientRect().top + window.pageYOffset - 90;
      window.scrollTo({ top: y, behavior: rm.matches ? 'auto' : 'smooth' });
    }
  });
  dlg.addEventListener('click', function (e) {
    if (e.target === dlg) { hide(); return; }
    var b = e.target.closest('.kn-dlg__tabs button'); if (b) { setPg(+b.dataset.pg); return; }
    if (e.target.closest('#knDlgX')) { hide(); return; }
    if (e.target.closest('#knPrev') && open > 0) { fill(open - 1); return; }
    if (e.target.closest('#knNext') && open < V.length - 1) { fill(open + 1); return; }
  });
  dlg.addEventListener('cancel', function (e) { e.preventDefault(); hide(); });
  dlg.addEventListener('keydown', function (e) {
    if (e.key === 'ArrowLeft' && open > 0) fill(open - 1);
    if (e.key === 'ArrowRight' && open < V.length - 1) fill(open + 1);
  });

  /* the PDF preview (apex-preview.js) restores body scroll when it closes; this modal is still open underneath */
  var pvd = document.getElementById('apx-pv');
  if (pvd) pvd.addEventListener('close', function () { if (dlg.open) { document.body.style.overflow = 'hidden'; $('knDlgPv').focus(); } });

  /* when the layout flips (rotation, resize across 900px) resync the stage */
  if (narrow.addEventListener) narrow.addEventListener('change', function () { onScroll(); stage(); });
  onScroll(); stage();
})();
